module.exports = __webpack_public_path__ + "static/edamame-fe7fc9ed66f253c51368042e439cdc02.jpg";